import { withModifiers as _withModifiers, createVNode as _createVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, createTextVNode as _createTextVNode, vModelText as _vModelText, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-82074e30")

_pushScopeId("data-v-82074e30")
const _hoisted_1 = { class: "tabs is-centered is-boxed mt-5" }
const _hoisted_2 = { class: "mb-5" }
const _hoisted_3 = { class: "methods-wrap" }
const _hoisted_4 = { key: 2 }
const _hoisted_5 = { class: "box not-available-box" }
const _hoisted_6 = { class: "mb-3 comment-wrap" }
const _hoisted_7 = { class: "select is-size-6 mb-2" }
const _hoisted_8 = {
  key: 0,
  class: "message is-warning mb-4"
}
const _hoisted_9 = { class: "message-body" }
const _hoisted_10 = {
  key: 1,
  class: "message is-info mb-4"
}
const _hoisted_11 = { class: "message-body" }
const _hoisted_12 = {
  key: 2,
  class: "message is-warning mb-4"
}
const _hoisted_13 = /*#__PURE__*/_createVNode("div", { class: "message-body" }, " You have already used 2 days of Special absence this year. ", -1)
const _hoisted_14 = {
  key: 3,
  class: "work-part-time-check"
}
const _hoisted_15 = { class: "checkbox" }
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" I work part-time ⌚️ ")
const _hoisted_17 = { key: 0 }
const _hoisted_18 = /*#__PURE__*/_createVNode("p", { class: "make-up-absence-info" }, " Do you work part-time ? Freely mark your absence, it won't be perceived as a holiday. ", -1)
const _hoisted_19 = { key: 4 }
const _hoisted_20 = { class: "half-day-check" }
const _hoisted_21 = { class: "checkbox" }
const _hoisted_22 = /*#__PURE__*/_createTextVNode(" Half-day absence 🌗 ")
const _hoisted_23 = {
  key: 0,
  class: "half-day-time"
}
const _hoisted_24 = /*#__PURE__*/_createVNode("p", { class: "half-day-absence-info" }, [
  /*#__PURE__*/_createTextVNode(" Choose your "),
  /*#__PURE__*/_createVNode("strong", null, "working hours' 4h slot"),
  /*#__PURE__*/_createTextVNode(" when you're gonna be "),
  /*#__PURE__*/_createVNode("strong", null, "available"),
  /*#__PURE__*/_createTextVNode(". "),
  /*#__PURE__*/_createVNode("br"),
  /*#__PURE__*/_createTextVNode(" Remaining 4 hours will be your half-day absence. ")
], -1)
const _hoisted_25 = /*#__PURE__*/_createVNode("div", { class: "labels" }, [
  /*#__PURE__*/_createVNode("span", { class: "label" }, [
    /*#__PURE__*/_createTextVNode("From "),
    /*#__PURE__*/_createVNode("sup", null, "*")
  ]),
  /*#__PURE__*/_createVNode("span", { class: "label" }, [
    /*#__PURE__*/_createTextVNode("To "),
    /*#__PURE__*/_createVNode("sup", null, "*")
  ])
], -1)
const _hoisted_26 = { class: "field is-horizontal" }
const _hoisted_27 = { class: "field mr-4 mb-0" }
const _hoisted_28 = { class: "field mr-4 mb-0" }
const _hoisted_29 = /*#__PURE__*/_createVNode("div", { class: "label mt-4" }, "Comment", -1)
const _hoisted_30 = {
  key: 0,
  class: "message is-warning mt-4"
}
const _hoisted_31 = /*#__PURE__*/_createVNode("div", { class: "message-header" }, [
  /*#__PURE__*/_createVNode("p", null, "Absences will be reviewed by PMs")
], -1)
const _hoisted_32 = { class: "apply-unavailability" }
const _hoisted_33 = /*#__PURE__*/_createTextVNode(" Apply ")
const _hoisted_34 = /*#__PURE__*/_createVNode("span", { class: "icon" }, [
  /*#__PURE__*/_createVNode("i", { class: "fa fa-calendar-times" })
], -1)
const _hoisted_35 = { key: 3 }
const _hoisted_36 = /*#__PURE__*/_createVNode("span", { class: "icon" }, [
  /*#__PURE__*/_createVNode("i", { class: "fa fa-trash" })
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_day_template_form = _resolveComponent("day-template-form")
  const _component_select_day_template = _resolveComponent("select-day-template")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("ul", null, [
        _createVNode("li", {
          class: { 'is-active': _ctx.activeTab === _ctx.MyWorkTab.Template }
        }, [
          _createVNode("a", {
            onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.emit('active-tab-change', _ctx.MyWorkTab.Template)), ["prevent"]))
          }, " Template ")
        ], 2),
        _createVNode("li", {
          class: { 'is-active': _ctx.activeTab === _ctx.MyWorkTab.Custom }
        }, [
          _createVNode("a", {
            onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.emit('active-tab-change', _ctx.MyWorkTab.Custom)), ["prevent"]))
          }, " Custom Hours ")
        ], 2),
        _createVNode("li", {
          class: { 'is-active': _ctx.activeTab === _ctx.MyWorkTab.NotAvailable }
        }, [
          _createVNode("a", {
            onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.emit('active-tab-change', _ctx.MyWorkTab.NotAvailable)), ["prevent"]))
          }, " Not available ")
        ], 2),
        _createVNode("li", {
          class: { 'is-active': _ctx.activeTab === _ctx.MyWorkTab.Remove }
        }, [
          _createVNode("a", {
            onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.emit('active-tab-change', _ctx.MyWorkTab.Remove)), ["prevent"]))
          }, " Remove ")
        ], 2)
      ])
    ]),
    _createVNode("div", _hoisted_2, " Selected day" + _toDisplayString(_ctx.selectedDays.length > 1 ? 's' : '') + ": " + _toDisplayString(_ctx.selectedDays.join(', ')), 1),
    _createVNode("div", _hoisted_3, [
      (_ctx.activeTab === _ctx.MyWorkTab.Custom)
        ? (_openBlock(), _createBlock(_component_day_template_form, {
            key: 0,
            "submit-text": 'Apply',
            onSubmit: _cache[5] || (_cache[5] = day => _ctx.emit('apply-to-selection', day)),
            "day-template": _ctx.selectedDay
          }, null, 8, ["day-template"]))
        : _createCommentVNode("", true),
      (_ctx.activeTab === _ctx.MyWorkTab.Template)
        ? (_openBlock(), _createBlock(_component_select_day_template, {
            key: 1,
            "submit-text": "Apply",
            onSubmit: _cache[6] || (_cache[6] = day => _ctx.emit('apply-to-selection', day))
          }))
        : _createCommentVNode("", true),
      (_ctx.activeTab === _ctx.MyWorkTab.NotAvailable)
        ? (_openBlock(), _createBlock("div", _hoisted_4, [
            _createVNode("div", _hoisted_5, [
              _createVNode("div", _hoisted_6, [
                _createVNode("div", _hoisted_7, [
                  _withDirectives(_createVNode("select", {
                    class: "select-input",
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.selectedAbsenceType = $event))
                  }, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.absenceOptions, ({ key, name }) => {
                      return (_openBlock(), _createBlock("option", {
                        key: key,
                        value: key,
                        disabled: _ctx.isAbsenceOptionDisabled(key)
                      }, _toDisplayString(name), 9, ["value", "disabled"]))
                    }), 128))
                  ], 512), [
                    [_vModelSelect, _ctx.selectedAbsenceType]
                  ])
                ]),
                (_ctx.paidLeaveLimitReached && !_ctx.isSelectedDayPaidLeave)
                  ? (_openBlock(), _createBlock("article", _hoisted_8, [
                      _createVNode("div", _hoisted_9, _toDisplayString(_ctx.paidLeaveInfoMessage), 1)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.januaryCarryoverAvailable && !_ctx.paidLeaveLimitReached)
                  ? (_openBlock(), _createBlock("article", _hoisted_10, [
                      _createVNode("div", _hoisted_11, " You have " + _toDisplayString(_ctx.unavailableDays?.paid.carriedOver) + " carried over paid leave day(s) for January. Remaining: " + _toDisplayString(_ctx.unavailableDays?.paid.carriedOverRemaining) + ". ", 1)
                    ]))
                  : _createCommentVNode("", true),
                (
                _ctx.specialAbsenceLimitReached && !_ctx.selectedDay.occasionalAbsence
              )
                  ? (_openBlock(), _createBlock("article", _hoisted_12, [
                      _hoisted_13
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.isUserPartTimeEmployee && _ctx.notAvailable)
                  ? (_openBlock(), _createBlock("div", _hoisted_14, [
                      _createVNode("label", _hoisted_15, [
                        _withDirectives(_createVNode("input", {
                          type: "checkbox",
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.markedByPartTimeUser = $event)),
                          onChange: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.adjustChecksDueToPartTimeJob && _ctx.adjustChecksDueToPartTimeJob(...args)))
                        }, null, 544), [
                          [_vModelCheckbox, _ctx.markedByPartTimeUser]
                        ]),
                        _hoisted_16
                      ]),
                      (_ctx.markedByPartTimeUser)
                        ? (_openBlock(), _createBlock("div", _hoisted_17, [
                            _hoisted_18
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                (
                (_ctx.notAvailable || _ctx.unpaid || _ctx.occasionalAbsence || _ctx.atConference) &&
                !_ctx.markedByPartTimeUser
              )
                  ? (_openBlock(), _createBlock("div", _hoisted_19, [
                      _createVNode("div", _hoisted_20, [
                        _createVNode("label", _hoisted_21, [
                          _withDirectives(_createVNode("input", {
                            type: "checkbox",
                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.halfNotAvailable = $event)),
                            onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.setDefaultTime()))
                          }, null, 512), [
                            [_vModelCheckbox, _ctx.halfNotAvailable]
                          ]),
                          _hoisted_22
                        ])
                      ]),
                      (_ctx.halfNotAvailable)
                        ? (_openBlock(), _createBlock("div", _hoisted_23, [
                            _hoisted_24,
                            _hoisted_25,
                            _createVNode("div", _hoisted_26, [
                              _createVNode("div", _hoisted_27, [
                                _withDirectives(_createVNode("input", {
                                  class: ["input", { 'is-danger': _ctx.timesInvalidity }],
                                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.halfNotAvailableStartTime = $event)),
                                  pattern: "^\\d\\d:\\d\\d$",
                                  placeholder: "10:00",
                                  onInput: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.checkTimesAreValidAndSet4hStep && _ctx.checkTimesAreValidAndSet4hStep(...args)))
                                }, null, 34), [
                                  [_vModelText, _ctx.halfNotAvailableStartTime]
                                ])
                              ]),
                              _createVNode("div", _hoisted_28, [
                                _withDirectives(_createVNode("input", {
                                  class: ["input", { 'is-danger': _ctx.timesInvalidity }],
                                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_ctx.halfNotAvailableEndTime = $event)),
                                  placeholder: "14:00",
                                  pattern: "^\\d\\d:\\d\\d$",
                                  onInput: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.checkTimesAreValidAndSet4hStep && _ctx.checkTimesAreValidAndSet4hStep(...args))),
                                  disabled: true
                                }, null, 34), [
                                  [_vModelText, _ctx.halfNotAvailableEndTime]
                                ])
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                _hoisted_29,
                _withDirectives(_createVNode("textarea", {
                  class: "textarea",
                  placeholder: _ctx.commentPlaceholderText,
                  "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (_ctx.comment = $event))
                }, null, 8, ["placeholder"]), [
                  [_vModelText, _ctx.comment]
                ])
              ]),
              (
              (_ctx.notAvailable || _ctx.unpaid || _ctx.occasionalAbsence) &&
              !_ctx.markedByPartTimeUser
            )
                ? (_openBlock(), _createBlock("article", _hoisted_30, [
                    _hoisted_31
                  ]))
                : _createCommentVNode("", true),
              _createVNode("div", _hoisted_32, [
                _hoisted_33,
                _createVNode("button", {
                  class: "button is-danger is-outlined ml-2 mr-2",
                  disabled: _ctx.haveToFillTimeWhenHalfAbsence,
                  onClick: _cache[17] || (_cache[17] = ($event: any) => (
                _ctx.emit('apply-not-available-to-selection', _ctx.notAvailableIndicators)
              ))
                }, [
                  _hoisted_34,
                  _createVNode("span", null, _toDisplayString(_ctx.finishMarkingUnavailabilityText), 1)
                ], 8, ["disabled"])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.activeTab === _ctx.MyWorkTab.Remove)
        ? (_openBlock(), _createBlock("div", _hoisted_35, [
            _createVNode("button", {
              class: "button is-danger is-outlined",
              onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.emit('remove-selection')))
            }, [
              _createVNode("span", null, "Remove day" + _toDisplayString(_ctx.selectedDays.length > 1 ? 's' : ''), 1),
              _hoisted_36
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
})